import { useEffect, useState } from "react";
import { isAuthenticated } from "../providers/api";

const keepAliveInterval = 1000 * 60 * 4;

export const useKeepAlive = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>();
  const [isReady, setIsReady] = useState<boolean>(false);

  useEffect(() => {
    isAuthenticated().then((res) => {
      setIsLoggedIn(res);
      if (res === true) {
        setIsReady(true);
      }
    });
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV === "production" && isLoggedIn === false) {
      const interval = setInterval(() => {
        const origin = window.location.origin;
        fetch(`${origin}/htk/h.jsp`)
          .then((res) => {
            if (res.status !== 200) {
              throw Error(`Keepalive failed with status ${res.status}`);
            }
          })
          .catch((err) => {
            console.error("Keepalive failed", err);
          });
      }, keepAliveInterval);
      setIsReady(true);
      return () => {
        clearInterval(interval);
      };
    } else if (process.env.NODE_ENV !== "production") {
      setIsReady(true);
    }
  }, [isLoggedIn]);
  return isReady;
};
